<template>
  <v-app-bar app :elevation=3>
    <v-icon v-if="iconPage != null" large class="mr-3">{{ iconPage }}</v-icon>
    <v-toolbar-title class="font-weight-light headline">
      {{ titlePage }}
    </v-toolbar-title>
    <div class="spacer"></div>
    <!-- <v-toolbar-title class="font-weight-light headline">
      {{ partner }}
    </v-toolbar-title> -->
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="getLogout">
          <v-icon class="mr-3">mdi-logout</v-icon>
          <v-list-item-title class="body-2 font-weight-light">Sair</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      partner: '',
      userId: '',
      titlePage: '',
      iconPage: null
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async getLogout() {

      try {
        await this.logout()
      }
      catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.message)
      }
      finally {
        this.$router.push('/login')
      }

    },
    getProfile() {
      this.$router.push('user')
    }
  },
  watch: {
    '$route' (to) {
      const meta = to.matched.reduce((acc, route) => {
        return {
          ...acc,
          ...route.meta
        }
      }, {})

      if (meta.title) {
        this.titlePage = meta.title
      }

      if (meta.icon) {
        this.iconPage = meta.icon
      } else {
        this.iconPage = null
      }

    }
  },
  created() {
    this.titlePage = this.$route.meta.title || this.$appName
    if (this.$route.meta.icon) {
      this.iconPage = this.$route.meta.icon
    }
  }
}
</script>
